import React from "react";

const ChartCard = ({
    title,
    height = 420,
    children,
}) => {
    return (
        <div
            style={{
                background: "#fff",
                borderRadius: 12,
                padding: 20,
                boxShadow: "0 2px 8px rgba(0,0,0,.08)",
            }}
        >
            <h4
                style={{
                    textAlign: "center",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#6b7280",
                    marginBottom: "16px",
                    letterSpacing: "0.3px",
                }}
            >
                {title}
            </h4>

            <div style={{ height }}>
                {children}
            </div>
        </div>
    );
};

export default ChartCard;